module.exports = __webpack_public_path__ + "img/dialog_header.f01ad3a5.png";